module.exports = __webpack_public_path__ + "img/sport3.1480621b.png";